import './App.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Prefer recaptcha.net over google.com so CookieYes advertising blocks
// do not prevent the login widget from rendering.
const win = window as Window & {
  recaptchaOptions?: { useRecaptchaNet?: boolean };
};
win.recaptchaOptions = { ...win.recaptchaOptions, useRecaptchaNet: true };

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App />);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
